import { gql } from '@apollo/client';

export function overrideCostAndCharges() {
  return gql`
    mutation overrideCostAndCharges(
      $amendmentId: String!
      $ChargesVariance: Decimal!
      $PolicyCostVariance: Decimal!
      $TPAFeesVariance: Decimal!
    ) {
      production {
        actions {
          overrideCostAndCharges(
            amendmentId: $amendmentId
            ChargesVariance: $ChargesVariance
            PolicyCostVariance: $PolicyCostVariance
            TPAFeesVariance: $TPAFeesVariance
          ) {
            id
          }
        }
      }
    }
  `;
}
